import React, { useEffect, useState, useRef, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, Box } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import Color from '@tool/color';
import { CloseIcon20, ArrowDown } from '@styled/icon';
import { newRate } from '@tool/index';
import moIndex, {
  chooseSingleIndustry, hoverSingle, leaveSingle, notFoundIndustry,
  hoverModal, leaveModal,
} from '../store/index';
import {
  LineBox, DButton, EButton, FButton, IndustryButton, IndustryLine,
} from './styled';
import moUser from '@store/user';

interface IProps {}
interface IState {}

const Single = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { singleIndustry, industry, currentSingle } = moIndex;

  useEffect(() => {
    return () => {};
  }, []);

  // onMouseLeave={() => leaveSingle(item.info.code)}
  return (
    <section className="popover-11011"
      onMouseEnter={hoverModal} onMouseLeave={leaveModal}>
      <section className="one-11011">
        {singleIndustry.map((item: any, index: number) => (
          <Fragment key={index}>
            {!isEmpty(item.sub_industries) ? (
              <LineBox onMouseEnter={() => hoverSingle(item.info.code)}
                className={[item.info.active ? 'active' : ''].join(' ')}>
                {/** onClick={() => chooseSingleIndustry(item.info.code, item.info.name)} */}
                <DButton className="industry-111">{item.info.name}</DButton>

                {item.hot_industries?.slice(0, 1)?.map((child: any, idx: number) => (
                  <FButton key={idx} onClick={() => chooseSingleIndustry(child.code, child.name)}
                    className="industry-113">{child.name}
                  </FButton>
                ))}
                {/* {item.info.name !== '全行业' ? ( */}
                  <p className="arrow-111">
                    <ArrowDown color={Color.blackColor(0.25)} />
                  </p>
                {/* ) : null} */}
              </LineBox>
            ) : null}
          </Fragment>
        ))}
        <p className="bottom-111">
          <EButton onClick={notFoundIndustry}>找不到想要的行业?</EButton>
        </p>
      </section>

      {currentSingle ? (
        <section className="two-11011">
          <p className="title-111">{currentSingle?.info?.name}</p>
          <IndustryLine>
            {currentSingle?.sub_industries?.map((item: any, index: number) => (
              <IndustryButton key={index}
                onClick={() => chooseSingleIndustry(item.code, item.name)}
                className={industry.code === item.code ? 'active-111' : ''}>{item.name}
              </IndustryButton>
            ))}
          </IndustryLine>
          <section className="two-11013">
            <p className="line-161">{currentSingle?.info?.description}</p>
          </section>
        </section>
      ) : null}
    </section>
  );
};

export default observer(Single);
